import styled, { keyframes } from 'styled-components'

const SpinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
}`

export default styled.span`
  border: 2px solid #1d233a;
  border-radius: 50%;
  border-top: 2px solid var(--wg-dark-blue);
  display: inline-block;
  width: 30px;
  height: 30px;
  animation: ${SpinAnimation} 2s linear infinite;

  /* Mostly for storybook visual tests but valid class name to add if we want */
  &.reduce-motion {
    animation: none;
  }

  @media (prefers-reduced-motion) {
    & {
      animation: none;
    }
  }
`
